import { createTheme } from '@mui/material/styles';
import { breakpoints } from '@fdc/theme/breakpoints';
import { typography } from '@fdc/theme/typography';
import palette from './colors';

const theme = createTheme({
  typography,
  breakpoints,
  palette,
  shape: {
    borderRadius: 2,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontSize: 14,
        },
        body: {
          margin: 0,
          backgroundColor: palette.ghostWhite,
          fontFamily: ['Plus Jakarta Sans', 'sans-serif'].join(','),
          fontSize: 14,
        },
      },
    },
  },
});

export default theme;
